export const quantityCounterConstants ={
    INCREASE_QUANTITY:"INCREASE_QUANTITY",
    DECREASE_QUANTITY:"DECREASE_QUANTITY"
}